//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Icon from "./Icon";
import MattingSlider from "./MattingSlider";
import vClickOutside from "v-click-outside";
// import { computed } from "@/service/store";

const { fsms, store, computed } = window.MattingEngineModule;

let minBrushSize = 10;
export default {
  name: "MattingControls",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  setup() {
    const { state, send } = fsms.getControlsFsm({
      context: {
        keepBrushSize: minBrushSize,
        eraseBrushSize: minBrushSize,
      },
    });
    return {
      state,
      send,
    };
  },
  filters: {
    percent(val) {
      if (typeof val === "number") {
        return Math.round(val * 100);
      } else {
        return val;
      }
    },
    mattingtypetxt(val) {
      if (val == "person") {
        return window.$apTranslations.Matting.person;
      } else if (val == "object") {
        return window.$apTranslations.Matting.object;
      } else {
        return window.$apTranslations.Matting.stamp;
      }
    },
  },
  components: {
    Icon,
    MattingSlider,
  },
  data() {
    return {
      minBrushSize,
      maxBrushSize: 250,
      brushSize: minBrushSize,
      // isShowBrushSize: false,
      isShowMatting: false,
    };
  },
  computed: {
    ...computed,
    zoomLevel() {
      return store.canvasManager.zoomLevel;
    },
    showEraseBrush() {
      return this.state.matches("brush.erase");
    },
    showKeepBrush() {
      return this.state.matches("brush.keep");
    },
    panActive() {
      return this.state.matches("pan");
    },
    hasControlAuth() {
      const mattingFsmState = computed.mattingFsmState();
      return mattingFsmState.matches("active");
    },
    isShowAdvanced() {
      return this.mattingFsmState && this.mattingFsmState.matches("editing");
    },
    undoDisabled() {
      return (
        store.canvasManager.stateshot &&
        store.canvasManager.stateshot.history.$index == 0
      );
    },
    redoDisabled() {
      let arr =
        store.canvasManager.stateshot &&
        store.canvasManager.stateshot.history.$records;
      let length;
      if (arr) {
        for (let i = arr.length - 1; i > -1; i--) {
          if (arr[i] != null) {
            length = i + 1;
            break;
          }
        }
      }
      return (
        store.canvasManager.stateshot &&
        length - store.canvasManager.stateshot.history.$index == 1
      );
    },
  },
  watch: {
    mattingFsmStatus(val) {
      if (val === "active") {
        this.pan();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      store.canvasManager.registeReset(() => {
        this.send("PENDING");
      });
    });
  },
  methods: {
    onClickOutside() {
      const brushType = this.state.value["brush"];
      if (brushType) {
        this.send({
          type: "CHILD_MACHINE",
          event: "CLOSE",
          brushType,
        });
      }
    },
    showMatting() {
      this.isShowMatting = !this.isShowMatting;
      this.onClickOutside();
      if (!this.panActive) {
        setTimeout(() => {
          this.send({
            type: "USE_PAN",
          });
        });
      }
    },
    changeMatting(type) {
      store.mattingFsm.send({
        type: "CHANGE_MATTING",
        mattingType: type,
      });
    },
    keep() {
      this.isShowMatting = false;
      this.send({
        type: "USE_BRUSH_KEEP",
      });
    },
    erase() {
      this.isShowMatting = false;
      this.send({
        type: "USE_BRUSH_ERASE",
      });
    },
    pan() {
      setTimeout(() => {
        this.send({
          type: "USE_PAN",
        });
      });
    },
    onBrushSizeChanged(x) {
      const brushType = this.state.value["brush"];
      this.send({
        type: "CHILD_MACHINE",
        event: "CHANGE",
        brushSize: x,
        brushType,
      });
      document.getElementsByClassName(
        "matting-engine__indicator"
      )[0].style.left = "50%";
      document.getElementsByClassName(
        "matting-engine__indicator"
      )[0].style.top = "50%";
    },
    zoomIn() {
      store.canvasManager.zoomIn();
    },
    zoomOut() {
      store.canvasManager.zoomOut();
    },
    undo() {
      const stateshot = store.canvasManager.stateshot;
      stateshot.replay("undo");
    },
    redo() {
      const stateshot = store.canvasManager.stateshot;
      stateshot.replay("redo");
    },
    edit() {
      store.mattingFsm.send({
        type: "EDIT",
      });
    },
    advancedFeatures() {
      this.$root.showModalApp = true;
      this.$root.modalAppStatus = "finish";
      this.$nextTick(
        function () {
          document.querySelector(".modal-app").classList.add("feature");
        }.bind(this)
      );
    },
  },
};
